interface MetricCardProps {
  label: string;
  value: string;
  change: string;
  trend: 'up' | 'down' | 'warning' | 'neutral';
  icon: string;
  iconBg: string;
  iconColor: string;
  accent: string;
  onClick?: () => void;
}

export default function MetricCard({
  label,
  value,
  change,
  trend,
  icon,
  iconBg,
  iconColor,
  accent,
  onClick,
}: MetricCardProps) {
  const trendConfig = {
    up:      { icon: 'ri-arrow-up-line',      color: 'text-semantic-success' },
    down:    { icon: 'ri-arrow-down-line',     color: 'text-semantic-error' },
    warning: { icon: 'ri-alert-line',          color: 'text-semantic-warning' },
    neutral: { icon: 'ri-subtract-line',       color: 'text-foreground-400' },
  };

  const t = trendConfig[trend];

  return (
    <div
      className={`bg-background-50 rounded-xl p-5 border border-background-200 ${accent} transition-all duration-200 hover:-translate-y-0.5 hover:shadow-raised group ${onClick ? 'cursor-pointer' : 'cursor-default'}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}
    >
      <div className="flex items-start justify-between mb-4">
        <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${iconBg} transition-transform duration-200 group-hover:scale-110`}>
          <i className={`${icon} text-lg ${iconColor}`} />
        </div>
        <div className={`flex items-center gap-1 text-xs font-label font-medium ${t.color}`}>
          <i className={t.icon} />
          <span>{change}</span>
        </div>
      </div>
      <div>
        <p className="font-heading font-700 text-foreground-900 text-2xl leading-none">{value}</p>
        <p className="text-foreground-500 text-sm font-label mt-1.5">{label}</p>
      </div>
    </div>
  );
}